var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./structure.class", "../schema/data-schema.class"], function (require, exports, structure_class_1, data_schema_class_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ArrayStructure = /** @class */ (function (_super) {
        __extends(ArrayStructure, _super);
        function ArrayStructure(func, defaultValue, _arrayLength) {
            if (_arrayLength === void 0) { _arrayLength = 1; }
            var _this = _super.call(this, func, defaultValue) || this;
            _this._arrayLength = _arrayLength;
            return _this;
        }
        Object.defineProperty(ArrayStructure.prototype, "defaultValue", {
            get: function () {
                if (this._defaultValue instanceof data_schema_class_1.DataSchema) {
                    var arr = [];
                    for (var i = 0; i < this._arrayLength; i++) {
                        arr.push(this._defaultValue.generateModel());
                    }
                    return arr;
                }
                else if (this._defaultValue instanceof structure_class_1.Structure) {
                    var arr = [];
                    for (var i = 0; i < this._arrayLength; i++) {
                        arr.push(this._defaultValue.defaultValue);
                    }
                    return arr;
                }
                else {
                    return this._defaultValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        ArrayStructure.prototype.length = function (length) {
            this._stack.push(function (val) {
                return val.length === length;
            });
            return this;
        };
        ArrayStructure.prototype.minLength = function (min) {
            this._stack.push(function (val) {
                return val.length >= min;
            });
            return this;
        };
        ArrayStructure.prototype.maxLength = function (max) {
            this._stack.push(function (val) {
                return val.length <= max;
            });
            return this;
        };
        ArrayStructure.prototype.string = function () {
            return this._isTypeOf("string");
        };
        ArrayStructure.prototype.number = function () {
            return this._isTypeOf("number");
        };
        ArrayStructure.prototype.schema = function (schema, version) {
            if (version === void 0) { version = null; }
            this._stack.push(function (val) {
                for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
                    var elem = val_1[_i];
                    if (schema instanceof data_schema_class_1.DataSchema) {
                        if (!schema.validateModel(elem, version)) {
                            return false;
                        }
                    }
                    else if (schema instanceof structure_class_1.Structure) {
                        if (!schema.getStackValidity(elem)) {
                            return false;
                        }
                    }
                }
                return true;
            });
            return this;
        };
        ArrayStructure.prototype._isTypeOf = function (type) {
            this._stack.push(function (val) {
                for (var _i = 0, val_2 = val; _i < val_2.length; _i++) {
                    var elem = val_2[_i];
                    if ((typeof elem) !== type) {
                        return false;
                    }
                }
                return true;
            });
            return this;
        };
        return ArrayStructure;
    }(structure_class_1.Structure));
    exports.ArrayStructure = ArrayStructure;
});
